import _ from 'lodash';

export default function notifIsNotExpired(notif) {
  let active = true;
  if (_.get(notif, 'slot_details')) {
    const start = new Date(`${notif.slot_details.date}, ${notif.slot_details.start}`).getTime();
    active = start > new Date().getTime();
  }
  return active;
}
